export const socials = [
    {telegram: "https://t.me/VladislavDesu"},
    {linkedin: "https://www.linkedin.com/in/vladislav-gryadko/"},
    {github: "https://github.com/VladislavDesu"},
    {twitter: "https://twitter.com/VladislavDesu"},
];